import React from 'react'
import ReactDOM from 'react-dom'
import InventoryInfowindow from './InventoryInfowindow'
import OutsideAlerter from '../../components/OutsideClicker'
import {markerIcon} from './LoadingAsset'

const InfoClick = (asset, map, marker, infowindow) => {
  
  const closeInfoWindow = () =>{
    if(marker.open){
      infowindow.close()
      marker.setIcon(markerIcon(false))
      marker.open = false
      
    }

  }
  var div = document.createElement("div")
  div.setAttribute("id", "infoWindow")
  ReactDOM.render(
    <OutsideAlerter eventListener='click' onClickOutside={closeInfoWindow}>
    <InventoryInfowindow asset={asset}  closeInfoWindow = {closeInfoWindow}/>
  </OutsideAlerter>
    ,
    div
  )
  infowindow.setContent(div)
  infowindow.open(map, marker)
  marker.open = true
}

export default InfoClick
